const initialState = {
  loading: false,
  events: [],
  eventGroup: [],
  selectedEvent: {},
};

const eventsReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "GET_EVENT_DATA": {
      return {
        ...state,
        loading: actions.loading,
        events: actions.data,
      };
    }
    case "LOADING_EVENT":{
      return{
        ...state,
        loading: actions.loading,
      }
    }
    case "UPDATE_EVENT": {
      return { ...state, events: actions.data };
    }
    case "GET_EVENT_GROUPS": {
      return { ...state, eventGroup: actions.data };
    }
    case "SET_SELECTED_EVENT": {
      return { ...state, selectedEvent: actions.data };
    }
    case "CLEAR_EVENT": {
      return { ...state, selectedEvent: [] };
    }
    default:
      return state;
  }
};
export default eventsReducer;
